// Single source of truth for the toll-free SMS/lead-alert number. Used by the
// signup consent checkbox, the footer, and the legal pages so the number stays
// consistent everywhere SMS is referenced.
export const SMS_NUMBER = '+18445429091';            // E.164 (tel: links)
export const SMS_NUMBER_DISPLAY = '+1 (844) 542-9091';
